import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const PorcentajeFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='PORCENTAJE' htmlFor='input-porcentaje' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='porcentaje'>
          {({ field }) => (
            <Form.InputNumber
              {...field}
              id='input-porcentaje'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(PorcentajeFormGroup)
